import React, { useEffect, useState } from 'react';
import axios from "axios";
import { Typography, styled, LinearProgress, Backdrop, CircularProgress } from '@mui/material';
import { EventEmitter } from "../../common/events";
import { eventKeys } from '../../common/constants';

const PREFIX = 'Loader';

const classes = {
  root: `${PREFIX}-root`,
  backdrop: `${PREFIX}-backdrop`,
  backdrophide: `${PREFIX}-backdrophide`,
  loadingBox: `${PREFIX}-loadingBox`,
  loadingText: `${PREFIX}-loadingText`
};

const Root = styled('span')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: theme.zIndex.modal + 2
  },

  [`& .${classes.backdrop}`]: {
    zIndex: theme.zIndex.modal + 1
  },

  [`& .${classes.backdrophide}`]: {
    display: "none"
  },

  [`& .${classes.loadingBox}`]: {
    textAlign: "center",
    background: theme.palette.common.white,
    opacity: 0.9,
    borderRadius: 5,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: theme.palette.grey[300],
    padding: 5,
    position: "absolute",
    top: 200,
    margin: "0 auto"
  },

  [`& .${classes.loadingText}`]: {
    fontWeight: 500
  }
}));

export default function Loader() {

  const [loadingCount, setLoadingCount] = useState(0);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    configureLoader();
  }, []); // eslint-disable-line
  //Configure Loader only once in app start

  const configureLoader = () => {
    axios.interceptors.request.use(function (config) {
      incrementLoadingCount();
      return config;
    }, function (error) {
      return Promise.reject(error);
    });

    axios.interceptors.response.use(function (response) {
      decrementLoadingCount();
      return response;
    }, function (error) {
      decrementLoadingCount();
      return Promise.reject(error);
    });
    EventEmitter.subscribe(eventKeys.HideLoader, hideLoader);
    EventEmitter.subscribe(eventKeys.ShowLoader, displayLoader);
  }

  const hideLoader = () => {
    setShowLoader(false);
  }

  const displayLoader = () => {
    setShowLoader(true);
  }

  const incrementLoadingCount = () => {
    let currentLoadingCount = loadingCount;
    currentLoadingCount++;
    setLoadingCount(currentLoadingCount);
  }

  const decrementLoadingCount = () => {
    let currentLoadingCount = loadingCount;
    if (currentLoadingCount < 0) {
      currentLoadingCount = 0;
    }
    else {
      currentLoadingCount--;
    }
    setLoadingCount(currentLoadingCount);
  }

  return (
    <Root>
      {loadingCount > 0 &&
        <React.Fragment>
          <div className={classes.root}>
            <LinearProgress variant="indeterminate" color="secondary" />
          </div>
          <Backdrop invisible={false} className={showLoader ? classes.backdrop : classes.backdrophide} open={true}>
            <div className={classes.loadingBox}>
              <CircularProgress color="primary" thickness={4} />
              <Typography color="primary" className={classes.loadingText}>Please Wait...</Typography>
            </div>
          </Backdrop>
        </React.Fragment>}
    </Root>
  );
}